import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu when route changes
    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-remy-dark/90 backdrop-blur-md shadow-lg border-b border-white/10' : 'bg-transparent'}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    <div className="flex-shrink-0">
                        <Link
                            to="/"
                            onClick={(e) => {
                                if (location.pathname === '/') {
                                    e.preventDefault();
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }
                            }}
                            className="flex items-center space-x-2 group"
                        >
                            <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-remy-primary to-remy-accent group-hover:from-remy-accent group-hover:to-remy-primary transition-all duration-300">
                                Remy Group
                            </span>
                        </Link>
                    </div>

                    <div className="hidden md:block">
                        <div className="ml-10 flex items-baseline space-x-8">
                            <Link
                                to="/"
                                onClick={(e) => {
                                    if (location.pathname === '/') {
                                        e.preventDefault();
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }
                                }}
                                className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-white/5"
                            >
                                Home
                            </Link>
                            <Link
                                to="/#apps"
                                onClick={(e) => {
                                    if (location.pathname === '/') {
                                        e.preventDefault();
                                        const el = document.getElementById('apps');
                                        if (el) el.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                                className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-white/5"
                            >
                                Apps
                            </Link>
                            <Link
                                to="/#games"
                                onClick={(e) => {
                                    if (location.pathname === '/') {
                                        e.preventDefault();
                                        const el = document.getElementById('games');
                                        if (el) el.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                                className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-white/5"
                            >
                                Games
                            </Link>
                            <Link to="/privacy" className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-white/5">Privacy Policy</Link>
                        </div>
                    </div>

                    <div className="-mr-2 flex md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-white/10 focus:outline-none"
                        >
                            {isOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile menu */}
            <div className={`md:hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'} bg-remy-dark/95 backdrop-blur-md`}>
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-white/10">
                    <Link
                        to="/"
                        onClick={(e) => {
                            setIsOpen(false);
                            if (location.pathname === '/') {
                                e.preventDefault();
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        }}
                        className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-white/5"
                    >
                        Home
                    </Link>
                    <Link
                        to="/#apps"
                        onClick={(e) => {
                            setIsOpen(false);
                            if (location.pathname === '/') {
                                e.preventDefault();
                                const el = document.getElementById('apps');
                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}
                        className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-white/5"
                    >
                        Apps
                    </Link>
                    <Link
                        to="/#games"
                        onClick={(e) => {
                            setIsOpen(false);
                            if (location.pathname === '/') {
                                e.preventDefault();
                                const el = document.getElementById('games');
                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}
                        className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-white/5"
                    >
                        Games
                    </Link>
                    <Link to="/privacy" className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-white/5">Privacy Policy</Link>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
